import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-external-link-icon lucide-external-link",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M15 3h6v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 14 21 3" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" })
	]
});
export default SvgExternalLink;
